import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "_flexinline _gap-1" }
const _hoisted_2 = {
  key: 2,
  class: "_tc--dark"
}
const _hoisted_3 = {
  class: "_tc--accent",
  "data-qa": "learn-more"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.classList)
  }, [
    _createElementVNode("div", _hoisted_1, [
      ($props.icon)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            name: $props.icon,
            "icon-namespace": $props.iconNamespace,
            class: "_tc--accent"
          }, null, 8 /* PROPS */, ["name", "icon-namespace"]))
        : _createCommentVNode("v-if", true),
      ($props.imageUrl)
        ? (_openBlock(), _createBlock(_component_base_image, {
            key: 1,
            src: $props.imageUrl,
            height: "14",
            alt: $props.imageAlt
          }, null, 8 /* PROPS */, ["src", "alt"]))
        : _createCommentVNode("v-if", true),
      ($props.text)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($props.text), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryLearnMoreButton), 1 /* TEXT */)
  ], 2 /* CLASS */))
}